import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import authenticationHelper from 'shared/helpers/authenticationHelper';
import goToS1 from 'shared/helpers/redirectionHelper';
import RefreshIndicatorLoading from 'shared/components/refreshIndicatorLoading/RefreshIndicatorLoading';
import { S1_PORTAL_URL } from 'shared/constants/SharedConstants';
import { s1SessionStorage } from 's1-service-ui-components';
import './otplogin.scss';

const orgId = new URL(document.location).searchParams.get('org');

class OTPLogin extends Component {
  state = {
    showErrorModal: false
  }

  componentDidMount = () => {
    const otp = new URL(document.location).searchParams.get('otp');
    if (otp) {
      sessionStorage.clear();
      s1SessionStorage.setS1Context(orgId);
      try {
        const s1PlatformUrl = window.utm_configs.S1_PLATFORM_URL;
        if (s1PlatformUrl) {
          sessionStorage.setItem(S1_PORTAL_URL, s1PlatformUrl);
        }
      } catch (e) {
        // config not available
      }
      authenticationHelper.storeOtpToken(otp);
      this.props.actions.otpLogin();
    } else if (this.props.userLogged) {
      this.fetchContexts();
    } else {
      goToS1();
    }
  }

  componentWillReceiveProps = nextProps => {
    if (this.props.loggingIn && !nextProps.loggingIn) {
      if (
        nextProps.userLogged &&
        !this.props.isFetchingContexts &&
        !nextProps.isFetchingContexts
      ) {
        this.fetchContexts();

      } else {
        goToS1();
      }
    }
    if (
      (this.props.isFetchingPermissions &&
        !nextProps.isFetchingPermissions) ||
      (this.props.isFetchingContexts && !nextProps.isFetchingContexts)
    ) {
      if (nextProps.userPermissions.length && nextProps.selectedOrg.id) {
        this.props.history.push('/dashboard');
      }
    }
  }

  fetchContexts = () => {
    this.props.actions.fetchContexts(orgId);
    this.props.actions.fetchUserPermissions();
    this.props.actions.fetchUser();
  }

  handleOnOkClick = () => goToS1();

  render () {
    const { showErrorModal } = this.state;
    return (
      <div className="otp-login">
        <div>
          <RefreshIndicatorLoading
            style={ { backgroundColor: 'transparent' } }
          />
        </div>
        <Dialog
          title={ 'Error' }
          open={ showErrorModal }
          modal
          actions={
            <FlatButton
              label = "OK"
              onClick = { this.handleOnOkClick }
              key = { 'continue-button' }
            />
          }
        >
          <p>There was an error loading Use Tax Manager.  Please try logging in again. </p>
        </Dialog>
      </div>
    );
  }
}

OTPLogin.propTypes = {
  history: PropTypes.object.isRequired,
  selectedOrg: PropTypes.object.isRequired,
  loggingIn: PropTypes.bool.isRequired,
  userLogged: PropTypes.bool.isRequired,
  isFetchingContexts: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    otpLogin: PropTypes.func,
    fetchUserPermissions: PropTypes.func,
    fetchContexts: PropTypes.func,
    fetchUser: PropTypes.func
  }).isRequired,
  isFetchingPermissions: PropTypes.bool.isRequired,
  userPermissions: PropTypes.array.isRequired
};

export default OTPLogin;



// WEBPACK FOOTER //
// ./src/components/otpLogin/OTPLogin.js